import { TEndpoint } from 'contexts/app-context/types'

import {
  TPreparedTicketFile,
  TSelectedTicketFile,
  TTicketFileWithS3Uri,
  TUploadUrlRequest,
  TUploadUrlResponse,
} from '../types/NewService.types'

interface GetPreparedTicketFilesParams {
  endpoint?: TEndpoint
  externalId?: string
  isEditService: boolean
  selectedFiles: TSelectedTicketFile[]
  getUploadUrls: (
    request: TUploadUrlRequest & { endpoint: TEndpoint },
  ) => Promise<TUploadUrlResponse>
}

export const hasPendingUploadPreparation = (
  selectedFiles: TSelectedTicketFile[],
  preparedFiles: TPreparedTicketFile[],
) => selectedFiles.length > 0 && preparedFiles.length !== selectedFiles.length

export const toTicketFiles = (preparedFiles: TPreparedTicketFile[]): TTicketFileWithS3Uri[] =>
  preparedFiles.map(({ name, size, type, s3Uri }) => ({
    name,
    size,
    type,
    s3Uri,
  }))

export const getPreparedTicketFiles = async ({
  endpoint,
  externalId,
  isEditService,
  selectedFiles,
  getUploadUrls,
}: GetPreparedTicketFilesParams) => {
  if (!endpoint || (isEditService && !externalId)) {
    return null
  }

  const response = await getUploadUrls({
    endpoint,
    ...(isEditService ? { externalId } : {}),
    files: selectedFiles.map((file) => ({
      fileName: file.name,
      contentType: file.type,
    })),
  })

  if (response.files.length !== selectedFiles.length) {
    throw new Error('Invalid upload URLs response')
  }

  return selectedFiles.map((file, index) => ({
    ...file,
    uploadUrl: response.files[index].uploadUrl,
    s3Uri: response.files[index].s3Uri,
  }))
}
